<template>
  <div
    v-if="cardPages > 1"
    class="c-bitts-carousel__pagination"
    :class="{ disabled: paginationDisabled }"
  >
    <BittsButton
      aria-label="Previous"
      :class="{ disabled: currentCarouselPage === 1 }"
      type="neutral"
      class="c-bitts-carousel-nav__prev"
      :center-icon="['fak', 'chevron-left']"
      variant="outline"
      :size="size"
      @click="$emit('prev')"
    />
    <p class="mx-16 text-neutral-text">
      {{ currentCarouselPage }} / {{ cardPages }}
    </p>
    <BittsButton
      aria-label="Next"
      :class="{
        disabled: currentCarouselPage === cardPages,
      }"
      type="neutral"
      class="c-bitts-carousel-nav__next"
      :center-icon="['fak', 'chevron-right']"
      variant="outline"
      :size
      :disabled="paginationDisabled"
      @click="$emit('next')"
    />
  </div>
</template>

<script setup lang="ts">
import BittsButton from '../BittsButton/BittsButton.vue';

export type CarouselPaginationSize = 'small' | 'medium' | 'large';

type Props = {
  cardPages: number;
  paginationDisabled: boolean;
  currentCarouselPage: number;
  size?: CarouselPaginationSize;
};

const {
  cardPages,
  paginationDisabled,
  currentCarouselPage,
  size = 'medium',
} = defineProps<Props>();

defineEmits<{
  next: [];
  prev: [];
}>();
</script>
<style lang="pcss" scoped>
@reference "../../../../apps/crossbeam-app/src/css/theme.css";
.c-bitts-carousel__pagination {
  @apply flex items-center;
}

.c-bitts-carousel-nav__prev,
.c-bitts-carousel-nav__next {
  @apply px-8 cursor-pointer transition-opacity delay-100 duration-300;
}
</style>
